import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import { Game, Firebase, Auth } from '../../../../../Core'
import * as MapSelectors from '../../../map.selectors'
import * as PhaseSelectors from '../../../../Phases/phases.selectors'
import * as indicatorsSelectors from '../../../../Indicators/indicators.selectors'
import * as MapActions from '../../../map.actions'
import * as battlesActions from '../../../../Battles/battles.actions'
import * as battlesSelectors from '../../../../Battles/battles.selectors'

import UpgradePanel from './UpgradePanel'

const mapStateToProps = (state) => {
  return {
    buildings: MapSelectors.getBuildings(state),
    attacking: MapSelectors.getAttackState(state),
    selectedTile: MapSelectors.getSelectedTile(state),
    currentPhase: PhaseSelectors.getCurrentPhase(state),
    visitorMap: MapSelectors.getVisitorMap(state),
    visitorInfo: MapSelectors.getVisitorInfo(state),
    userMap: MapSelectors.getUserMap(state),
    parameters: MapSelectors.getBuildingParameters(state),
    cursorPos: Game.selectors.getCursorPosition(state),
    userData: indicatorsSelectors.getUserData(state),
    battles: battlesSelectors.getUserBattles(state),
    playersList: Firebase.selectors.getPlayerList(state),
    userInfo: Auth.selectors.getUserInfo(state),
    isTutorialMode: false,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
    createBuilding: bindActionCreators(MapActions.createBuilding, dispatch),
    createBattle: bindActionCreators(battlesActions.createBattle, dispatch),
    setIndividualBattle: bindActionCreators(battlesActions.setIndividualBattle, dispatch),
    upgradeBuilding: bindActionCreators(MapActions.upgradeBuilding, dispatch),
    destroyBuilding: bindActionCreators(MapActions.destroyBuilding, dispatch),
    repareBuilding: bindActionCreators(MapActions.repareBuilding, dispatch),
    removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UpgradePanel))
